import React from 'react'

const CommingSoon = () => {
    return (
        <>

            {/* REGISTER */}
            <section>
                <div className="login pg-soon">
                    <div className="container">
                        <div className="row">
                            <div className="inn">
                                <div className="tit">
                                    <h4>We are building our website.</h4>
                                    <h1>Comming soon</h1>
                                </div>
                                <div className="menu-pop-soci">
                                    <ul>
                                        <li>
                                            <a href="#!">
                                                <i className="fa fa-facebook" aria-hidden="true" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#!">
                                                <i className="fa fa-twitter" aria-hidden="true" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#!">
                                                <i className="fa fa-whatsapp" aria-hidden="true" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#!">
                                                <i className="fa fa-linkedin" aria-hidden="true" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#!">
                                                <i className="fa fa-youtube-play" aria-hidden="true" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#!">
                                                <i className="fa fa-instagram" aria-hidden="true" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="counter">
                                    <div className="timer">
                                        <div>
                                            <span className="days">10</span>
                                            <i>Days</i>
                                        </div>
                                        <div>
                                            <span className="hours">53</span>
                                            <i>Hours</i>
                                        </div>
                                        <div>
                                            <span className="minutes">09</span>
                                            <i>Minutes</i>
                                        </div>
                                        <div>
                                            <span className="seconds">32</span>
                                            <i>Seconds</i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END */}

        </>

    )
}

export default CommingSoon